export function luhnCheck(cardNumber: string): boolean {
    const digits = cardNumber.replace(/\D/g, '');
    if (digits.length === 0) {
        return false;
    }

    let sum = 0;
    let alternate = false;

    for (let i = digits.length - 1; i >= 0; i--) {
        let n = parseInt(digits[i], 10);
        if (alternate) {
            n *= 2;
            if (n > 9) {
                n -= 9;
            }
        }
        sum += n;
        alternate = !alternate;
    }

    return sum % 10 === 0;
}

export function isValidCardLength(cardNumber: string): boolean {
    const digits = cardNumber.replace(/\D/g, '');
    return digits.length >= 13 && digits.length <= 19;
}

export function isCardBrandConsistent(
    detectedBrand: string,
    selectedType: string,
): boolean {
    if (!detectedBrand || !selectedType) {
        return true;
    }

    const brandToType: Record<string, string> = {
        visa: 'visa',
        mastercard: 'mc',
        discover: 'disc',
        'american-express': 'amex',
    };

    const expected = brandToType[detectedBrand];
    return !expected || expected === selectedType;
}

export function isValidExpiration(expiration: string): {
    valid: boolean;
    reason?: string;
} {
    const match = expiration.match(/^(\d{2})\/(\d{2})$/);
    if (!match) {
        return { valid: false, reason: 'Expiration must be in MM/YY format.' };
    }

    const month = parseInt(match[1], 10);
    if (month < 1 || month > 12) {
        return { valid: false, reason: 'Expiration month must be between 01 and 12.' };
    }

    const year = 2000 + parseInt(match[2], 10);
    const now = new Date();
    const currentMonth = now.getMonth() + 1;
    const currentYear = now.getFullYear();

    if (year < currentYear || (year === currentYear && month < currentMonth)) {
        return { valid: false, reason: 'Card expiration date is in the past.' };
    }

    return { valid: true };
}

export function isValidCvv(cvv: string, cardBrand: string): {
    valid: boolean;
    reason?: string;
} {
    const digits = cvv.replace(/\D/g, '');
    const isAmex = cardBrand === 'american-express';
    const expectedLength = isAmex ? 4 : 3;

    if (digits.length !== expectedLength) {
        return {
            valid: false,
            reason: isAmex
                ? 'American Express requires a 4-digit CID.'
                : 'CVV must be 3 digits.',
        };
    }

    return { valid: true };
}
